import { createReducer, on } from '@ngrx/store';
import * as PolicyActions from './policy.actions';

export interface PolicyState {
  data: any;
  loading: boolean;
  dcPolicyLoading: boolean;
  dcBillingLoading: boolean;
  dmsLoading: boolean;
  paymentScheduleLoading: boolean;
  error: string | null;
  policyNumber: string | null;
}

export const initialState: PolicyState = {
  data: null,
  loading: false,
  dcPolicyLoading: false,
  dcBillingLoading: false,
  dmsLoading: false,
  paymentScheduleLoading: false,
  error: null,
  policyNumber: null,
};

export const policyReducer = createReducer(
  initialState,
  on(PolicyActions.loadPolicyData, (state, { policyNumber }) => ({
    ...state,
    dcPolicyLoading: true,
    dcBillingLoading: true,
    dmsLoading: true,
    loading: true,
    error: null,
    policyNumber,
  })),
  on(PolicyActions.loadDCPolicy, (state, { policyNumber }) => ({
    ...state,
    dcPolicyLoading: true,
    loading: true,
    error: null,
    policyNumber,
  })),
  on(PolicyActions.loadDCPolicySuccess, (state, { policyNumber, policySnapshot }) => {
    const newState = {
      ...state,
      dcPolicyLoading: false,
      paymentScheduleLoading: true,
      data: {
        ...state.data,
        [policyNumber]: {
          ...state.data?.[policyNumber],
          policySnapshot,
        },
      },
    };
    return {
      ...newState,
      loading: newState.dcPolicyLoading || newState.dcBillingLoading || newState.dmsLoading,
    };
  }),
  on(PolicyActions.loadDCPolicyFailure, (state, { error }) => {
    const newState = { ...state, dcPolicyLoading: false, error };
    return {
      ...newState,
      loading: newState.dcPolicyLoading || newState.dcBillingLoading || newState.dmsLoading,
    };
  }),
  on(PolicyActions.loadDCBillingSuccess, (state, { policyNumber, billingSnapshot }) => {
    const newState = {
      ...state,
      dcBillingLoading: false,
      data: {
        ...state.data,
        [policyNumber]: {
          ...state.data?.[policyNumber],
          billingSnapshot,
        },
      },
    };
    return {
      ...newState,
      loading: newState.dcPolicyLoading || newState.dcBillingLoading || newState.dmsLoading,
    };
  }),
  on(PolicyActions.loadDCBillingFailure, (state, { error }) => {
    const newState = { ...state, dcBillingLoading: false, error };
    return {
      ...newState,
      loading: newState.dcPolicyLoading || newState.dcBillingLoading || newState.dmsLoading,
    };
  }),
  on(PolicyActions.loadDMSSuccess, (state, { policyNumber, dmsSnapshot }) => {
    const newState = {
      ...state,
      dmsLoading: false,
      data: {
        ...state.data,
        [policyNumber]: {
          ...state.data?.[policyNumber],
          dmsSnapshot,
        },
      },
    };
    return {
      ...newState,
      loading: newState.dcPolicyLoading || newState.dcBillingLoading || newState.dmsLoading,
    };
  }),
  on(PolicyActions.loadDMSFailure, (state, { error }) => {
    const newState = { ...state, dmsLoading: false, error };
    return {
      ...newState,
      loading: newState.dcPolicyLoading || newState.dcBillingLoading || newState.dmsLoading,
    };
  }),
  on(PolicyActions.loadPaymentScheduleSuccess, (state, { policyNumber, paymentSchedule }) => ({
    ...state,
    paymentScheduleLoading: false,
    data: {
      ...state.data,
      [policyNumber]: {
        ...state.data?.[policyNumber],
        paymentSchedule,
      },
    },
  })),
  on(PolicyActions.loadPaymentScheduleFailure, (state, { error }) => ({
    ...state,
    paymentScheduleLoading: false,
    error,
  })),
  on(PolicyActions.clearPolicyStore, () => ({ ...initialState }))
);
